// 描述：预览工具页面，主要用在采编中心，网站或APP渠道。当一个节点绑定多个模板时，该页面选择展现预览页功能的工具页面
// 日期：2017/1/5
'use strict';
angular.module('previewToolModule', []).factory('previewToolService', ['$state', 'trsHttpService', function($state, trsHttpService) {
    
    /**
     * [previewFunc description]
     *
     * @param {[type]} data   [data description]
     * @param {[type]} item   [item description]
     *
     * @return {[type]}   [return description]
     */
    function previewFunc(data, item) {
        if (data.DATA[0].URLS.length > 1) {
            var currentName = $state.current.name.split('.')[3];
            var href = $state.href('previewtool', {
                id: item.CHANNELID || item.SITEID,
                issite: item.CHANNELID ? 'false' : 'true',
                isAll: currentName && currentName === 'all'
            });
            window.open(href);
        } else {
            window.open(data.DATA[0].URLS[0]);
        }
    }
    return {
        channelPreview: function(chl, successFunc) {
            var currentName = $state.current.name.split('.')[3];
            var preParams = {
                serviceid: 'mlf_publish',
                methodname: 'preview',
                ObjectIds: chl.CHANNELID,
                ObjectType: '101',
                TopChannelId: '0',
                allStatus: (currentName && currentName === 'all') || $state.params.isAll, // 全部时此参数为true
            };
            if (chl.TOPCHNLID) {
                preParams.TopChannelId = chl.TOPCHNLID === chl.CHANNELID ? 0 : chl.TOPCHNLID;
            }
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), preParams, 'post').then(function(data) {
                if (angular.isDefined(successFunc) && angular.isFunction(successFunc)) {
                    successFunc(data);
                } else {
                    previewFunc(data, chl);
                }
            });
        },
        sitePreview: function(site, successFunc) {
            var preParams = {
                serviceid: 'mlf_publish',
                methodname: 'preview',
                ObjectIds: site.SITEID,
                ObjectType: '103',
                TopChannelId: '0',
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), preParams, 'post')
                .then(function(data) {
                    if (angular.isDefined(successFunc) && angular.isFunction(successFunc)) {
                        successFunc(data);
                    } else {
                        previewFunc(data, site);
                    }
                });
        }
    };
}]).controller('previewToolCtrl', ['$stateParams', '$scope', 'previewToolService', function($stateParams, $scope, previewToolService) {
    initStatus();
    initData();

    /**
     * [initStatus description]初始化状态
     * @return {[type]}   [return description]
     */
    function initStatus() {
        $scope.data = {};
        $scope.status = {
            isSite: $stateParams.issite === 'true',
            id: $stateParams.id,
            showMenu: true
        };
        // delete $rootScope.previewUrlList;
    }

    /**
     * [initData description]初始化数据
     *
     * @return {[type]}   [return description]
     */
    function initData() {
        getUrl();
    }

    /**
     * [getUrl description]获取地址
     *
     * @return {[type]}   [return description]
     */
    function getUrl() {
        if ($scope.status.isSite) {
            previewToolService.sitePreview({ SITEID: $scope.status.id }, dealResult);
        } else {
            previewToolService.channelPreview({ CHANNELID: $scope.status.id }, dealResult);
        }
    }

    /**
     * [dealResult description]处理结果
     *
     * @param {[type]} data   [data description]
     *
     * @return {[type]}   [return description]
     */
    function dealResult(data) {
        $scope.data.urlList = data.DATA[0].URLS;
        $scope.data.currUrl = $scope.data.urlList[0];
        $scope.data.name = data.DATA[0].NAME;
        $scope.data.currIndex = 0;
    }
    $scope.selectUrl = function(url, index) {
        $scope.data.currUrl = url;
        $scope.data.currIndex = index;
    };
}]);
